import { render, staticRenderFns } from "./prueba2.vue?vue&type=template&id=444c0b2f"
import script from "./prueba2.vue?vue&type=script&lang=js"
export * from "./prueba2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports